/* assets/benefit-badges.js */
(() => {
  "use strict";

  const MOBILE_QUERY = "(max-width: 749px)";
  const REDUCE_QUERY = "(prefers-reduced-motion: reduce)";

  // Mobile: 1 item por vez (baixo -> cima) em loop
  const MOBILE_INTERVAL_MS = 2500;     // tempo entre trocas
  const MOBILE_TRANSITION_MS = 600;    // suavidade da transição

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;
  const reduced = () => window.matchMedia(REDUCE_QUERY).matches;

  const $all = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function removeClones(track) {
    track.querySelectorAll("[data-bb-clone='1']").forEach((n) => n.remove());
  }

  function cleanup(wrapper) {
    if (wrapper._bbTimer) {
      clearInterval(wrapper._bbTimer);
      wrapper._bbTimer = null;
    }

    const track = wrapper.querySelector(".benefit-track");
    if (track) {
      removeClones(track);
      track.style.transition = "";
      track.style.transform = "";
    }

    wrapper.classList.remove("bb--overflow");
    wrapper.style.removeProperty("--bb-shift");
    wrapper.style.removeProperty("--bb-row-h");
    wrapper.dataset.bbMode = "";
  }

  // DESKTOP: calcula o shift baseado no último badge (mais confiável)
  function initDesktop(wrapper) {
    const track = wrapper.querySelector(".benefit-track");
    if (!track) return;

    removeClones(track);

    // Zera transform pra medir corretamente
    track.style.transition = "none";
    track.style.transform = "translateX(0px)";
    void track.offsetHeight;

    const lastBadge = track.querySelector(".benefit-badge:last-child");
    if (!lastBadge) return;

    const wRect = wrapper.getBoundingClientRect();
    const lastRect = lastBadge.getBoundingClientRect();

    // Quanto do último badge está "pra fora" do wrapper (lado direito)
    const overflow = Math.max(0, Math.ceil(lastRect.right - wRect.right));

    if (overflow > 1) {
      wrapper.classList.add("bb--overflow");
      // folga de 4px pra garantir que chegue no final mesmo com rounding/gap
      wrapper.style.setProperty("--bb-shift", `${-(overflow + 4)}px`);
    } else {
      wrapper.classList.remove("bb--overflow");
      wrapper.style.setProperty("--bb-shift", `0px`);
    }

    wrapper.dataset.bbMode = "desktop";
  }

  // MOBILE: vertical (baixo -> cima), 1 por vez, loop infinito
  function initMobile(wrapper) {
    const track = wrapper.querySelector(".benefit-track");
    if (!track) return;

    removeClones(track);

    const items = $all(".benefit-badge", track);
    if (items.length <= 1) {
      wrapper.style.removeProperty("--bb-row-h");
      return;
    }

    // clone do primeiro para loop infinito
    const clone = items[0].cloneNode(true);
    clone.setAttribute("data-bb-clone", "1");
    track.appendChild(clone);

    // Altura de 1 item (pra janela ficar certinha)
    const firstH = items[0].getBoundingClientRect().height || 0;
    wrapper.style.setProperty("--bb-row-h", `${Math.ceil(firstH) + 4}px`);

    // step = itemHeight + gap vertical (se houver)
    const st = getComputedStyle(track);
    const gap = parseFloat(st.gap || st.rowGap || "0") || 0;
    const step = Math.ceil(firstH + gap);

    let idx = 0;

    // estado inicial
    track.style.transition = "none";
    track.style.transform = "translateY(0px)";
    void track.offsetHeight;

    wrapper._bbTimer = setInterval(() => {
      idx += 1;

      // anima para cima (baixo -> cima)
      track.style.transition = `transform ${MOBILE_TRANSITION_MS}ms cubic-bezier(.22,.61,.36,1)`;
      track.style.transform = `translateY(${-idx * step}px)`;

      // chegou no clone -> volta pro início sem pulo
      if (idx === items.length) {
        setTimeout(() => {
          track.style.transition = "none";
          track.style.transform = "translateY(0px)";
          idx = 0;
          void track.offsetHeight;
        }, MOBILE_TRANSITION_MS + 40);
      }
    }, MOBILE_INTERVAL_MS);

    wrapper.dataset.bbMode = "mobile";
  }

  function initOne(wrapper) {
    if (reduced()) {
      cleanup(wrapper);
      return;
    }

    const mode = isMobile() ? "mobile" : "desktop";
    if (wrapper.dataset.bbMode === mode) return;

    cleanup(wrapper);
    if (mode === "mobile") initMobile(wrapper);
    else initDesktop(wrapper);
  }

  function initAll() {
    $all("[data-benefit-badges]").forEach(initOne);
  }

  // init
  const run = () => initAll();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // quando a página termina de carregar (imagens/fontes), recalcula
  window.addEventListener("load", () => {
    run();
    setTimeout(run, 400);
    setTimeout(run, 1200);
  });

  // resize (troca mobile/desktop e recalcula medidas)
  let t = null;
  window.addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(run, 140);
  });

  // editor Shopify
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:reorder", run);
})();
